import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AdminAuthService } from './admin-auth.service';

export const rootGuard: CanActivateFn = () => {
  const auth = inject(AdminAuthService);
  return auth.canManageAdmins() ? true : inject(Router).createUrlTree(['/unauthorized']);
};
